module.exports = __webpack_public_path__ + "static/media/DOGE-BTC.c4a80e04.svg";